// Pfad: src/config/config.js
// Zweck/Funktion: Frontend-Konfig – API-Basis per ENV oder Fallback.

const browserHost =
  typeof window !== "undefined" && window.location && window.location.hostname
    ? window.location.hostname
    : "";

const fallbackURL =
  browserHost === "localhost" || browserHost === "127.0.0.1"
    ? "http://localhost:5000"
    : "https://api.experts4europe.com";
const envURL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = (envURL && envURL.startsWith("http")) ? envURL : fallbackURL;

if (!envURL || envURL === "undefined") {
  console.warn("[config.js] Warnung: REACT_APP_API_BASE_URL ist nicht gesetzt. Fallback wird verwendet:", fallbackURL);
}

const config = { API_BASE_URL };
export { API_BASE_URL };
export default config;
